import moment from 'moment';

// const strings = require('./locales/task/de.json')
// const language = window.navigator.userLanguage || window.navigator.language;
// moment.locale(language)
moment.locale('de');

export const getTaskProperties = task => {
  const extraInfo = {};
  if (task.due_date) {
    extraInfo.dueDate = moment(task.due_date).format('HH:mm');
    extraInfo.dueDay = moment(task.due_date).format('DD.MM.YYYY');
  } else {
    extraInfo.dueDate = null;
    extraInfo.dueDay = null;
  }

  if (task.done_at) {
    extraInfo.doneDate = moment(task.done_at).format('HH:mm');
    extraInfo.doneDay = moment(task.done_at).format('DD.MM.YYYY');
  } else {
    extraInfo.doneDate = null;
    extraInfo.doneDay = null;
  }

  return extraInfo;
};

export default getTaskProperties;



// WEBPACK FOOTER //
// ./src/models/Task.js